import { GenericPaginationParams } from "../types/api";
import { RitualCollectivePerksResponse } from "../types/ritualCollective";
import { get } from "./apiClient";


export const fetchRitualCollectivePerks = async (options: GenericPaginationParams = {}): Promise<RitualCollectivePerksResponse> => {
  const response = await get<RitualCollectivePerksResponse>(`api/v1/ritual_collective_perks?page=${options.page}&per_page=${options.perPage}`);

  return response.data;
};